import React from "react";
import {
  IntersectionAnimation,
  SliceConfig,
  TypeGrid as TypeGridComponent
} from "~components";
import { ISliceConfig, TFont } from "~schemas";

interface IProps {
  data: {
    toggleButtonStyle: {
      style: string;
    };
    font: TFont;
    sliceConfig: ISliceConfig;
  };
}

const TypeGrid = ({
  data: { toggleButtonStyle, font, sliceConfig }
}: IProps) => (
  <section>
    <SliceConfig config={sliceConfig}>
      <IntersectionAnimation>
        <TypeGridComponent
          toggleButtonStyle={toggleButtonStyle}
          font={font}
          backgroundColor={sliceConfig.backgroundColor?.hex}
        />
      </IntersectionAnimation>
    </SliceConfig>
  </section>
);

export default TypeGrid;
